import type { EndCustomer, ReferencePoint } from "@/interfaces";
import L from "leaflet";
import { useEffect } from "react";
import { useMap } from "react-leaflet";

const MapBoundsFitter = ({
  customers,
  referencePoints,
  selectedCustomers,
  selectedReferencePoint,
}: {
  customers: EndCustomer[];
  referencePoints: ReferencePoint[];
  selectedCustomers: number[];
  selectedReferencePoint?: number;
}) => {
  const map = useMap();

  useEffect(() => {
    if (customers.length === 0) return;

    const positions: L.LatLngTuple[] = [];

    if (selectedCustomers.length > 0) {
      customers
        .filter((customer) => selectedCustomers.includes(customer.id))
        .forEach((customer) => {
          if (customer.latitude && customer.longitude) {
            positions.push([customer.latitude, customer.longitude]);
          }
        });
    } else {
      customers.forEach((customer) => {
        if (customer.latitude && customer.longitude) {
          positions.push([customer.latitude, customer.longitude]);
        }
      });
    }

    if (selectedReferencePoint) {
      const refPoint = referencePoints.find(
        (rp) => rp.id === selectedReferencePoint,
      );
      if (refPoint && refPoint.center_latitude && refPoint.center_longitude) {
        positions.push([
          parseFloat(refPoint.center_latitude),
          parseFloat(refPoint.center_longitude),
        ]);
      }
    }

    if (positions.length > 0) {
      map.fitBounds(L.latLngBounds(positions), {
        padding: [50, 50],
        maxZoom: 13,
        animate: true,
      });
    }
  }, [
    map,
    customers,
    referencePoints,
    selectedCustomers,
    selectedReferencePoint,
  ]);

  return null;
};

export default MapBoundsFitter;
